import React from "react";
import { formatRupiah } from "../../../helper/formatNumber";

import "./salesSummary.css";

const SalesSummary = ({ summaryData = {} }) => {
  return (
    <div className="sales-summary-container">
      <h3>Detail Penjualan</h3>
      <div className="sales-summary-transaction-table">
        <div className="sales-summary-row">
          <div
            style={{
              width: "15px",
              height: "15px",
              backgroundColor: "#F0F0F0",
              marginRight: "5px",
            }}
          ></div>
          <p className="sales-summary-column-title">Cash :</p>
          <p className="sales-summary-column">
            <b>{formatRupiah(summaryData?.cash_transaction ?? "0")}</b>
          </p>
        </div>
        <div className="sales-summary-row">
          <div
            style={{
              width: "15px",
              height: "15px",
              backgroundColor: "#FFF9C4",
              marginRight: "5px",
            }}
          ></div>
          <p className="sales-summary-column-title">Transfer :</p>
          <p className="sales-summary-column">
            <b>{formatRupiah(summaryData?.transfer_transaction ?? "0")}</b>
          </p>
        </div>
        <div className="sales-summary-row">
          <div
            style={{
              width: "15px",
              height: "15px",
              backgroundColor: "#C8E6C9",
              marginRight: "5px",
            }}
          ></div>
          <p className="sales-summary-column-title">Debit :</p>
          <p className="sales-summary-column">
            <b>{formatRupiah(summaryData?.debit_transaction ?? "0")}</b>
          </p>
        </div>
        <div className="sales-summary-row">
          <div
            style={{
              width: "15px",
              height: "15px",
              backgroundColor: "#FFE0B2",
              marginRight: "5px",
            }}
          ></div>
          <p className="sales-summary-column-title">QR :</p>
          <p className="sales-summary-column">
            <b>{formatRupiah(summaryData?.qr_transaction ?? "0")}</b>
          </p>
        </div>
        <div className="sales-summary-row">
          <div
            style={{
              width: "15px",
              height: "15px",
              backgroundColor: "#BBDEFB",
              marginRight: "5px",
            }}
          ></div>
          <p className="sales-summary-column-title">Kartu Kredit :</p>
          <p className="sales-summary-column">
            <b>{formatRupiah(summaryData?.credit_card_transaction ?? "0")}</b>
          </p>
        </div>
        <div className="sales-summary-row">
          <div
            style={{
              width: "15px",
              height: "15px",
              backgroundColor: "#D1C4E9",
              marginRight: "5px",
            }}
          ></div>
          <p className="sales-summary-column-title">Rekanan :</p>
          <p className="sales-summary-column">
            <b>{formatRupiah(summaryData?.partner_transaction ?? "0")}</b>
          </p>
        </div>
      </div>
      <div className="sales-summary-row">
        <div
          style={{
            width: "15px",
            height: "15px",
            backgroundColor: "#f56969ff",
            marginRight: "5px",
          }}
        ></div>
        <p className="sales-summary-column-title">ONLINE :</p>
        <p className="sales-summary-column">
          <b>{formatRupiah(summaryData?.online_transaction ?? "Rp. 0")}</b>
        </p>
      </div>
      <div className="separator" />
      <div className="sales-summary-row">
        <h2 className="sales-summary-column-title-transaction">
          Total Penjualan:
        </h2>
        <h3 className="sales-summary-column">
          <b>{formatRupiah(summaryData?.total_transaction ?? "0")}</b>
        </h3>
      </div>
    </div>
  );
};

export default SalesSummary;
